export default {
  data() {
    return {
      perPage: 0,
      lastPage: 0,
      currentPage: 1,
      loadingTbl: false
    }
  },
  computed: {
    // No more items
    isEmpty() {
      return this[this.arrayName || this.$route.name].length === 0
    },
    pageStartIndex() {
      return (this.currentPage - 1) * this.perPage
    },
  },

  methods: {
    // get current page from route
    getCurrentPage() {
      let parsedPage
      const page = this.$route.query.page

      // no page query string
      if (!page) {
        this.currentPage = 1
        return
      }

      if (Number.isInteger(Number(page)) && (parsedPage = parseInt(page)) >= 1) {
        // valid page query string
        this.currentPage = parsedPage
      } else {
        // invalid page query string
        this.$router.push({ path: '/dashboard/404' })
      }
    },

    // change page from pagination
    changePage(page) {
      if (page === parseInt(this.$route.query.page)) return

      const queryStrings = { ...this.$route.query, page: page }

      if (page === 1) {
        delete queryStrings.page
      }

      this.$router.push({ query: queryStrings })

      this.isSearching = true
      this.loadingTbl = true
    },
    generatePageInfo(currentPage, itemsPerPage, totalItems) {
      const startIndex = (currentPage - 1) * itemsPerPage + 1
      const endIndex = Math.min(currentPage * itemsPerPage, totalItems)
      return `Showing ${startIndex}-${endIndex} of ${totalItems} creators`
    },
  },
}
